import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";
import { Provider } from "react-redux";
import { store } from "./store";
//
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import ErrorDialog from "./components/error-dialogue/ErrorDialog";

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));

const token = localStorage.getItem("token");
if (token) axios.defaults.headers.common["authorization"] = token;

root.render(
  <Provider store={store}>
    <HelmetProvider>
      <BrowserRouter>
        <ErrorDialog />
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </Provider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
